import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  chip: {
    height: 100,
    marginLeft: 25,
    marginBottom: 15,
  },
  previewLarge: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  chipLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
